import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  ', '\n'], ['\n  ', '\n']);

import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { translations, utils } from 'gipsy-misc';
import { LargeButton } from './..';
import Title from '../TaskPanel/fields/Title';
import Reviewer from '../TaskPanel/fields/Reviewer';
import When from '../TaskPanel/fields/When';
import Watcher from '../TaskPanel/fields/Watcher';
import Requestor from '../TaskPanel/fields/Requestor';
import Description from '../TaskPanel/fields/Description';
import UrlInfo from '../TaskPanel/fields/UrlInfo';
import { panelStyle, Scrollable, Body, FooterContainer, CloseIcon } from '../Panel';

import get from 'lodash/get';

var View = function (_PureComponent) {
  _inherits(View, _PureComponent);

  function View() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, View);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = View.__proto__ || Object.getPrototypeOf(View)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: null
    }, _this.toggleField = function (e, id) {
      _this.setState({
        open: _this.state.open !== id ? id : null
      });
    }, _this.openField = function (e, id) {
      _this.setState({
        open: id
      });
    }, _this.closeAllFields = function (e, id) {
      _this.setState({
        open: null
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(View, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          reviewRequest = _props.reviewRequest,
          create = _props.create,
          onChange = _props.onChange,
          onImageUpload = _props.onImageUpload,
          defaultContacts = _props.defaultContacts,
          hideWatchers = _props.hideWatchers,
          hideWhen = _props.hideWhen,
          closePanel = _props.closePanel;
      var open = this.state.open;


      return React.createElement(
        TaskPanel,
        { loading: loading, className: 'task-panel', onClick: this.closeAllFields },
        React.createElement(CloseIcon, { icon: 'Close', className: 'close-icon', onClick: closePanel }),
        React.createElement(
          Scrollable,
          { className: 'panel-scrollable', ref: function ref(_ref2) {
              return _this2.panel = _ref2;
            } },
          React.createElement(
            Body,
            { className: 'panel-body' },
            React.createElement(Title, {
              mode: 'reviewRequest',
              isActive: true,
              isOpen: false,
              onSubmit: create,
              onChange: onChange,
              value: reviewRequest.title
            }),
            React.createElement(Reviewer, {
              mode: 'reviewRequest',
              id: 'reviewers',
              isActive: true,
              isOpen: open === 'reviewers',
              toggleField: this.toggleField,
              onChange: onChange,
              value: reviewRequest.watchers,
              reviewInputLinkValue: reviewRequest.reviewInputLink,
              defaultContacts: defaultContacts
            }),
            !hideWhen && React.createElement(When, {
              mode: 'reviewRequest',
              id: 'when.date',
              isActive: true,
              isOpen: open === 'when.date',
              toggleField: this.toggleField,
              onChange: onChange,
              showClose: false,
              label: utils.string.capitalize(translations.general.when),
              value: get(reviewRequest, 'when.date'),
              shouldHideRecurring: true,
              pinTime: get(reviewRequest, 'pin.time'),
              pinDate: get(reviewRequest, 'pin.date'),
              shouldHideBlockInCalendar: true
            }),
            !hideWatchers && React.createElement(Watcher, {
              mode: 'reviewRequest',
              id: 'watchers',
              isActive: true,
              isOpen: open === 'watchers',
              toggleField: this.toggleField,
              onChange: onChange,
              value: reviewRequest.watchers,
              defaultContacts: defaultContacts
            }),
            React.createElement(Requestor, { id: 'requestor', isActive: true, isOpen: false, value: reviewRequest.requestor }),
            React.createElement(Description, {
              id: 'description',
              isActive: true,
              isOpen: open === 'description',
              onChange: onChange,
              onImageUpload: onImageUpload,
              openField: this.openField,
              value: reviewRequest.description,
              uploads: reviewRequest.uploads,
              placeholderPath: 'reviewRequestPanel.description.placeholder'
            }),
            React.createElement(UrlInfo, { value: reviewRequest.urlInfo, isActive: true })
          )
        ),
        React.createElement(
          FooterContainer,
          null,
          React.createElement(
            LargeButton,
            { rightIconName: 'Plus', disabled: this.props.disabled, onClick: create },
            translations.reviewRequestPanel.create
          )
        )
      );
    }
  }]);

  return View;
}(PureComponent);

View.propTypes = {
  reviewRequest: PropTypes.object,
  create: PropTypes.func,
  onChange: PropTypes.func,
  onImageUpload: PropTypes.func,
  closePanel: PropTypes.func,
  disabled: PropTypes.bool,
  defaultContacts: PropTypes.array,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func
};


export default View;

var TaskPanel = styled.div(_templateObject, panelStyle);
//# sourceMappingURL=view.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/ReviewRequestPanel/view.js
// module id = 1134
// module chunks = 0